export enum EChoiceDisplayMode {
    RADIO = "radio",
    BUTTON = "button",
}
